import { BaseIntegration, BaseIntegrationState } from '@/models/integrations/BaseIntegration';
import { ReplacementTags } from '@/store/modules/global/state';
import { IntegrationBezzerwisserData } from './Data';

interface CampaignItemState {
  question: string;
  url: string;
  unixTime: number;
  date: string;
  id: number;
}

export interface IntegrationBezzerwisserState extends BaseIntegrationState {
  replacementTags: ReplacementTags;
  campaignsOverview: CampaignItemState[];
}

export class IntegrationBezzerwisserModel extends BaseIntegration<
  IntegrationBezzerwisserData,
  IntegrationBezzerwisserState
> {
  parse(data: IntegrationBezzerwisserData) {
    super.parse(data);
    this.state.replacementTags = data.settings?.replacementtags ?? {};

    if (data.settings?.campaigns_overview) {
      this.state.campaignsOverview = data.settings.campaigns_overview.map<CampaignItemState>((campaign) => {
        return {
          question: campaign.question,
          url: campaign.url,
          unixTime: campaign.unixtime,
          date: campaign.date,
          id: campaign.id
        };
      });
    } else {
      this.state.campaignsOverview = [];
    }
  }

  hasVueComponent() {
    return false;
  }

  authorSignature(): string {
    return 'Ani Mikova';
  }
}
